module.exports = "/static/assets/abf1ce5b92e4d0f6016a0215aa880ab3.png";